/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as transparentUpgradeableProxySol from "./TransparentUpgradeableProxy.sol";
export { ProxyAdmin__factory } from "./ProxyAdmin__factory";
